import { render } from "./TabelaSolicitacoes.vue?vue&type=template&id=50cedcb8&scoped=true"
import script from "./TabelaSolicitacoes.vue?vue&type=script&lang=js"
export * from "./TabelaSolicitacoes.vue?vue&type=script&lang=js"

import "./TabelaSolicitacoes.vue?vue&type=style&index=0&id=50cedcb8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50cedcb8"]])

export default __exports__